<form [formGroup]="formGroup">
  <div class="d-flex justify-content-between">
    <div class="d-flex align-items-center" *ngIf="showLongMessageInput">
      <!-- <wsb-ui-checkbox size="small" formControlName="longMessage" class="me-3 pt-1"></wsb-ui-checkbox> -->
      <input type="checkbox" formControlName="longMessage" class="me-3 pt-1" />
      <!-- <mat-checkbox formControlName="longMessage" class="me-3 pt-1"></mat-checkbox> -->

      <span translate class="textarea-header" [ngClass]="{ 'textarea-header--enabled': longMessageControl.value }"
        >sms_editor_charlimit_toggle</span
      >
    </div>
    <div [ngClass]="getCssTextAreaForTemplate()" [ngStyle]="{ color: textMetrics.totalCharCount > 160 ? 'red' : null }">
      <span class="textarea-header me-2">
        <strong>{{ textMetrics.totalCharCount }}/{{ textMetrics.totalCharLimit }}</strong> {{ 'sms_editor_counter_chars' | translate }}
      </span>
      <span class="textarea-header me-2">
        <!--  -->
        <strong
          >{{ textMetrics.smsCount }}<span *ngIf="textMetrics.smsLimit > 1">/{{ textMetrics.smsLimit }}</span></strong
        >
        {{ 'sms_editor_counter_sms' | translate }}
      </span>
    </div>
  </div>

  <div class="sms-textarea-container fake-textarea no-focus">
    <img hidden src="assets/images/emojis/64.png" />
    <ng-template #emojiContent>
      <emoji-mart
        title="Pick your emoji…"
        emoji="point_up"
        (emojiClick)="addEmoji($event)"
        virtualize="true"
        virtualizeOffset="500"
        [backgroundImageFn]="backgroundImageFn"
      ></emoji-mart>
    </ng-template>

    <!--     <wsb-atlas-button  size="sm"  class="emoji-btn" variant="icon" [icon]="faPreviewIcon" noHover="true" [roundButton]="true" [ngbPopover]="emojiContent" placement="top" popoverClass="emoji-popover" [autoClose]="'outside'"> </wsb-atlas-button> -->
    <textarea
      id="sms-textarea"
      class="form-control"
      [ngClass]="{ 'is-invalid': textControl.dirty && textControl.invalid }"
      rows="8"
      [formControl]="textControl"
      (blur)="onTextAreaBlur()"
    ></textarea>
  </div>

  <wsb-validation-error-msg [fc]="textControl" [hidden]="!(textControl.dirty && textControl.invalid)"></wsb-validation-error-msg>

  <p class="alert-dynamics-field" *ngIf="showAlertEmoji" translate>send_sms_emojialert</p>

  <p class="alert-dynamics-field" *ngIf="showAlert" translate>send_sms_dynamicalert</p>

  <div class="collapser" *ngIf="isShowSmsEncoding">
    <wsb-atlas-collapse label="sms_editor_encoding" [collapsed]="collapsedEncoding">
      <div class="d-flex">
        <div class="encoding-hint" translate>sms_editor_encoding_hint</div>
        <div
          class="tooltip-custom border rounded-circle border-1"
          #tooltip="matTooltip"
          matTooltipPosition="above"
          matTooltipClass="tooltip-class"
          matTooltip="{{ 'sms_editor_encoding_ucs2_help' | translate }}"
        >
          <p>?</p>
        </div>
      </div>

      <div class="form-check-inline encoding-selection">
        <label class="radio-custom">
          <input type="radio" id="gsmEncoding" formControlName="encoding" [value]="ENCODING_GSM" />
          <span class="radio-custom__radio"></span>
          <span class="radio-custom__label" translate>sms_editor_encoding_gsm</span>
        </label>
        <label class="radio-custom">
          <input type="radio" id="ucsEncoding" formControlName="encoding" [value]="ENCODING_UCS" />
          <span class="radio-custom__radio"></span>
          <span class="radio-custom__label" translate>sms_editor_encoding_ucs2</span>
        </label>
      </div>
    </wsb-atlas-collapse>
  </div>
</form>
